import { ticketing } from "./input/ticketing";
export const input = {
  namespaced: true,
  modules: {
    ticketing: ticketing,
  },
};
